<template>
    <div id="seeInviteHis">
        <div class="mybreadcrumb">
            <div style="display:flex;align-items:center">
                <i class="iconfont icon-qiye-tianchong" style="margin-right:10px;color:#999"></i>
                <el-breadcrumb separator-class="el-icon-arrow-right" >
                    <el-breadcrumb-item>企业管理</el-breadcrumb-item>
                    <el-breadcrumb-item>部门/成员管理</el-breadcrumb-item>
                    <el-breadcrumb-item>查看记录</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <button class="return-button" @click="returnClick">返回</button>
        </div>
        <p class="asmember-tittle">邀请记录({{InvitetableData.length}})</p>
        <div class="table-wraper">
            <el-table
                :data="InvitetableData"
                ref="abcdef"
                border
                :header-cell-style="{color:'#333333',fontFamily:'MicrosoftYaHei',fontSize:'12px',fontWeight:400,padding:'9px 0',background:'#F5F5F5'}"
                :cell-class-name="tabCellClassName"
                style="width: 100%">
                <el-table-column
                    label="序号"
                    type="index"
                    width="50"
                    align="center"
                    >
                <template slot-scope="scope">
                    <span>{{scope.$index + 1}}</span>
                </template>
                </el-table-column>
                <el-table-column
                    prop="phone"
                    width="120"
                    label="手机号"
                    align="center"
                    >
                </el-table-column>
                <el-table-column
                    prop="realName"
                    label="姓名/企业昵称"
                    width="100"
                    show-overflow-tooltip
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="department"
                    label="部门"
                    align="center"
                    show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                    prop="invitedAt"
                    label="邀请时间"
                    width="160"
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="addedAt"
                    label="加入时间"
                    width="160"
                    align="center"
                    show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                    prop="inviteStatus"
                    label=""
                    width="110"
                    align="center"
                    
                    >
                     <template slot="header">
                        <el-popover
                            ref="popoverRef"
                            placement="bottom"
                            trigger="click"
                            popper-class="inviteSelect"
                            @show="popoverShow"
                            @hide="popoverHide">
                            <ul class="select-wraper" @click="inviteChange">
                                <li :class="currentInviteStatus==='全部'?'liActive':''">全部</li>
                                <!-- <li :class="currentInviteStatus==='已邀请'?'liActive':''">已邀请</li>
                                <li :class="currentInviteStatus==='已加入'?'liActive':''">已加入</li> -->
                                
                                <li :class="currentInviteStatus==='已加入'?'liActive':''">已加入</li>
                                <li :class="currentInviteStatus==='已拒绝'?'liActive':''">已拒绝</li>
                                <li :class="currentInviteStatus==='待注册'?'liActive':''">待注册</li>
                                <li :class="currentInviteStatus==='待确认'?'liActive':''">待确认</li>
                                <li :class="currentInviteStatus==='已过期'?'liActive':''">已过期</li>
                                <li :class="currentInviteStatus==='已失效'?'liActive':''">已失效</li>
                            </ul>
                            <div slot="reference" style="cursor:pointer">
                                <span>状态</span>
                                <i v-show="isIconUp" class="el-icon-arrow-up" ></i>
                                <i v-show="!isIconUp" class="el-icon-arrow-down" ></i>
                            </div>
                            
                        </el-popover> 
                    </template>

                    <template slot-scope="scope">
                        <!-- <div v-if="scope.row.inviteStatus=='1'" class="table-status  bgcgreen">
                            <span>已加入</span>
                        </div>
                        <div v-else class="table-status bgcorange">
                            <span>已邀请</span>
                        </div> -->
                        <div v-if="scope.row.inviteStatus=='1'" class="table-status  bgcgreen">
                            <span>已加入</span>
                        </div>
                        <div v-else-if="scope.row.inviteStatus=='2'" class="table-status bgcred">
                            <span>已拒绝</span>
                        </div>
                        <div v-else-if="scope.row.inviteStatus=='4'" class="table-status bgcorange">
                            <span>待注册</span>
                        </div>
                        <div v-else-if="scope.row.inviteStatus=='5'" class="table-status bgcorange">
                            <span>待确认</span>
                        </div>
                        <div v-else-if="scope.row.inviteStatus=='6'" class="table-status bgcorange">
                            <span>已过期</span>
                        </div>
                        <div v-else-if="scope.row.inviteStatus=='7'" class="table-status bgcgrey">
                            <span>已失效</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        
    </div>
</template>

<script>
import {InviteUserList} from '@/js/enterPriseApi'
import Moment from 'moment'
import {MyZhugeTrackCkSeeInviteHis} from '@/js/zhugemaidian.js'

export default {
    data(){
        return{
            InvitetableData:[],
            currentInviteStatus:'全部',
            isIconUp:false
        }
    },
    created(){
        this.getInviteUserList();
    },
   mounted(){
       MyZhugeTrackCkSeeInviteHis();
   },
    methods:{
        tabCellClassName({row, column, rowIndex, columnIndex}){
            return 'cellstyle'
        },
        filterTag(value, row) {//表格筛选
            
            return row.inviteStatus === value;
        },
        returnClick(){
            this.$router.push('/comMbManage')
        },
        popoverShow(){
            this.isIconUp=true;
        },
        popoverHide(){
           this.isIconUp=false;
        },
        inviteChange(e){//下拉框切换事件
            this.currentInviteStatus=e.target.innerHTML;
            console.log(this.$refs.popoverRef);
            this.$refs.popoverRef.doClose();
            this.getInviteUserList();
        },
        getInviteUserList(){
            let that=this;
            let params=null;
            params={enterPriseId:window.localStorage.getItem('enterPriseId')};
            InviteUserList(params)
            .then(res=>{
                console.log(res)
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    that.InvitetableData=[];
                    that.$refs.abcdef.clearFilter();//情况筛选条件
                    
                    const filterData=data.filter(item=>{
                        
                        if(that.currentInviteStatus=='全部'){
                            return item.inviteStatus=='4'//待注册
                            ||item.inviteStatus=='5'//待确认
                            ||item.inviteStatus=='1' //已加入
                            ||item.inviteStatus=='2' //已拒绝
                            ||item.inviteStatus=='6' //已过期
                            ||item.inviteStatus=='7' //已失效
                        }else if(that.currentInviteStatus=='待注册'){
                            return item.inviteStatus=='4'
                        }else if(that.currentInviteStatus=='待确认'){
                            return item.inviteStatus=='5'
                        }else if(that.currentInviteStatus=='已加入'){
                            return item.inviteStatus=='1'
                        }else if(that.currentInviteStatus=='已拒绝'){
                            return item.inviteStatus=='2'
                        }else if(that.currentInviteStatus=='已过期'){
                            return item.inviteStatus=='6'
                        }else if(that.currentInviteStatus=='已失效'){
                            return item.inviteStatus=='7'
                        }

                    })
                    filterData.forEach(item=>{
                        let obj={
                            department:item.department,
                            phone:item.phone,
                            realName:item.realName,
                            userId:item.userId,
                            inviteStatus:item.inviteStatus,
                            addedAt:item.addedAt?Moment(item.addedAt).format('YYYY-MM-DD HH:mm:ss'):'',
                            invitedAt:item.invitedAt?Moment(item.invitedAt).format('YYYY-MM-DD HH:mm:ss'):''
                        }
                        that.InvitetableData.push(obj);
                    })
                }else{
                    this.$message.error(res.data.error_msg)
                }
                
            })
            .catch(err=>{
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            })
        }
    }
}
</script>
<style lang="scss">
    .el-table-filter__list{
        .el-table-filter__list-item{
            text-align: center;
        }
        .el-table-filter__list-item.is-active{
            background-color:#fff;
            color:#409eff;
        }
    }
</style>
<style scoped lang="scss">
    #seeInviteHis{
        background: #fff;
        min-height: 100%;
        /deep/ .el-breadcrumb{
            .el-breadcrumb__inner{
                font-family: MicrosoftYaHei;
                font-size: 12px;
                color: #666666;
                font-weight: 400;
            }
            .el-breadcrumb__separator{
                font-size: 12px !important;
                color: #666666;
            }
        }
        .mybreadcrumb{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 0 10px 20px;
            border-bottom: 1px solid #EAEAEA;
            .return-button{
                font-size: 12px;
                font-family: MicrosoftYaHei;
                margin-right: 20px;
                width: 60px;
                height: 30px;
                background: #F6F6F6;
                border: 1px solid #E0E0E0;
                border-radius: 2px;
                line-height: 30px;
                cursor: pointer;
                color: #666;
            }
            
        }
        .asmember-tittle{
            text-align: left;
            padding: 20px 0 15px 30px;
            font-family: FZLTZHK--GBK1-0;
            font-size: 14px;
            color: #333333;
            font-weight:600
        }
        .table-wraper{
            padding:0 20px 20px 20px;
        }
        .table-status{
            span{
                margin-left: 8px;
            }
        }
        .bgcorange::before{
                content:'';
                width: 10px;
                height: 10px;
                border-radius: 50%;
                display: inline-block;
                background: #FE833D;
            }
        .bgcgreen::before{
            content:'';
            width: 10px;
            height: 10px;
            border-radius: 50%;
            display: inline-block;
            background: #1DCB96;
        }
        .bgcred::before{
            content:'';
            width: 10px;
            height: 10px;
            border-radius: 50%;
            display: inline-block;
            background: #fe3d3d;
        }
        .bgcgrey::before{
            content:'';
            width: 10px;
            height: 10px;
            border-radius: 50%;
            display: inline-block;
            background: #c8c8c8;
        }
        //element-ui样式
        /deep/ .el-table .cellstyle{
            padding: 10px 0 !important;
            font-family: MicrosoftYaHei;
            font-size: 12px;
            color: #666666;
            font-weight: 400;
        }
    }
    
</style>

<style lang="scss">
    .inviteSelect{
        width: 100px !important;
        min-width:100px !important;
        max-width:100px !important;
        text-align:center;
        padding:  0px !important;
        .select-wraper{
            text-align: center;
                li{
                    padding: 7px 0;
                        cursor: pointer;
                }
                li:hover{
                    background:#ecf5ff;
                    color:#66b1ff;
                }
                .liActive{
                    color:#66b1ff;
                }
        }
    }
</style>


// WEBPACK FOOTER //
// src/view/CompanyUser/companyManage/seeInviteHis.vue